<template>
  <!--  中医养生-->
  <div>
    <!-- 顶部banner图 + 面包屑 -->
    <div style="width:100%;height:500px">
      <div id="banner1">
        <BannerSwiper msg="中医养生"></BannerSwiper>
      </div>
    </div>
    <div style="position: relative;top:10px;left:0px;" id="administrative">
      <breadcrumb msg="中医养生" id="breadcrumb"></breadcrumb>
    </div>
    <div id="swiper">
      <newsList :data="newList"></newsList>
      <div style="text-align:center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="filter.page"
          :page-size="filter.limit" background layout="prev, pager, next"
          :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import BannerSwiper from "../components/bannerSwiper";
  import Swiper from "swiper";
  import "../../node_modules/swiper/css/swiper.css";
  import breadcrumb from "../components/breadcrumb";
  import newsList from "../components/news"
  import {articlePage} from '../../api/api.js'

  export default {
    components: {breadcrumb, newsList, BannerSwiper},
    data() {
      return {
        id: '',
        filter: {
          keyword: '',
          status: '',
          page: 1,
          limit: 5,
          sort: "DESC",
          orderField: "pubdate",
          status: '0'
        },
        sectionList: JSON.parse(sessionStorage.getItem('sectionList')),
        newList: [],
        total: 0
      };
    },
    created() {
      for (let i = 0; i < this.sectionList.length; i++) {
        if (("/" + this.sectionList[i].url) === this.$route.path) {
          this.id = this.sectionList[i].id
          this.getNewList();
        }
      }
    },
    methods: {
      getNewList() {
        this.filter.sectionId = this.id
        articlePage(this.filter).then(res => {
          if (res.data.code === 200) {
            this.newList = res.data.data
            this.total = res.data.total
          }
        })
      },
      handleCurrentChange(val) {
        this.filter.page = val
        this.getNewList()
      }
    }
  };
</script>
<style lang="less" scoped>
  #banner1 {
    height: 500px;
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  #swiper {
    padding-top: 30px;
    background-image: url(../assets/img/jkjt3.jpg);

    h1 {
      text-align: center;
      color: #595959;
    }
  }

  #swiperBodyName {
    width: 80%;
    height: 80%;
    margin: 5px auto;
    line-height: 40px;
    background-image: url(../assets/img/pubc-tabs-icon3.png);
    background-size: 100% 100%;
  }

  #swiperBar {
    width: 550px;
    height: 50px;
    display: flex;
    color: #595959;
    font-weight: 600;
    margin: 0 auto;
    flex-direction: row;

    #left {
      background-image: url(../assets/img/pubc-tabs-icon1.png);
      background-size: 100% 100%;
      width: 30px;
    }

    .swiper-container {
      width: 1000px;
      text-align: center;
      float: left;
    }

    #right {
      background-image: url(../assets/img/pubc-tabs-icon2.png);
      background-size: 100% 100%;
      width: 30px;
    }
  }
</style>
